import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import {
  AuthProvider,
  GoogleAuthProvider,
} from "./components/modals/AuthContext";

// Defer SW registration until page is idle - avoids render blocking
if ("serviceWorker" in navigator) {
  const defer = (cb) => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(cb, { timeout: 3000 });
    } else {
      setTimeout(cb, 2000);
    }
  };
  window.addEventListener("load", () => {
    defer(() => {
      import("virtual:pwa-register")
        .then(({ registerSW }) => registerSW({ immediate: false }))
        .catch(() => {});
    });
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <GoogleAuthProvider>
        <App />
      </GoogleAuthProvider>
    </AuthProvider>
  </React.StrictMode>
);
